import { z } from 'zod';

export namespace TranscriptAPI {
  const contentSummarySchema = z.object({
    id: z.number(),
    generatedOn: z.date(),
    content: z.object({
      sections: z.object({
        title: z.string(),
        summary: z.string(),
      }).array(),
    }),
  });

  export namespace GetTranscriptMetadata {
    export const RequestParamsSchema = z.object({
      transcriptId: z.coerce.number(),
    });

    export const ResponseBodySchema = z.object({
      metadata: z.object({
        title: z.string(),
        publishedOn: z.date(),
      }),
    });
  }

  export namespace GetTranscriptMedia {
    export const RequestParamsSchema = z.object({
      transcriptId: z.coerce.number(),
    });

    export const ResponseBodySchema = z.object({
      captionsUrl: z.string().nullable(),
      url: z.url().nullable(),
    });
  }

  export namespace GetTranscriptSummary {
    export const requestParamsSchema = z.object({
      transcriptId: z.coerce.number(),
    });

    export const responseBodySchema = z.object({
      content: contentSummarySchema,
      items: z.unknown().array(),
    });
  }

  export namespace GenerateTranscriptSummary {
    export const requestParamsSchema = z.object({
      transcriptId: z.coerce.number(),
    });

    export const requestBodySchema = z.object({
      tagIds: z.coerce.number().array().prefault([]),
    });
  }

  export namespace GetTranscriptReport {
    export const requestParamsSchema = z.object({
      transcriptId: z.coerce.number(),
    });

    export const responseBodySchema = z.object({
      key: z.string(),
    });
  }

  export namespace GetTranscriptEntities {
    export const requestParamsSchema = z.object({
      transcriptId: z.coerce.number(),
    });

    export const responseBodySchema = z.object({
      entities: z.object({
        id: z.number(),
        value: z.string(),
        entityType: z.string(),
        occurrences: z.array(z.object({
          start: z.number(),
          end: z.number(),
        })),
        correctedValue: z.string().nullable(),
      }).array(),
    });

    export type Response = z.infer<typeof responseBodySchema>;
  }

  export namespace GetTranscriptExtractedData {
    export const requestParamsSchema = z.object({
      transcriptId: z.coerce.number(),
    });

    const extractedDataItemSchema = z.object({
      key: z.string(),
      title: z.string(),
      sources: z.unknown().nullable(),
      extractedData: z.unknown().nullable(),
      markdownSummary: z.string().nullable(),
      completedOn: z.date().nullable(),
    });

    export const responseBodySchema = z.object({
      items: z.array(extractedDataItemSchema),
    });

    export type ExtractedDataItem = z.infer<typeof extractedDataItemSchema>;
    export type Response = z.infer<typeof responseBodySchema>;
  }
}